import {PaymentMethod} from '@sollapay/enums';
import {IconLabelBadge} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {IconName} from '@sollapay/ui/components';
import type {FC} from 'react';

const METHOD_ICON: Record<PaymentMethod, IconName> = {
  [PaymentMethod.PIS]: 'coins-hand',
  [PaymentMethod.MANUAL]: 'bank-branch'
};

export interface PaymentMethodBadgeProps {
  method: PaymentMethod;
  /** i18n namespace to resolve the label from. */
  ns?: string;
  /**
   * Key prefix for the label, joined with `method` as `${labelKeyPrefix}.${method}` — the
   * `ns` namespace must expose one key per raw enum value under this prefix (e.g.
   * `instructions.methods.pis`, `instructions.methods.manual_transfer`).
   */
  labelKeyPrefix?: string;
  className?: string;
}

export const PaymentMethodBadge: FC<PaymentMethodBadgeProps> = ({
  method,
  ns = 'common',
  labelKeyPrefix = 'instructions.methods',
  className
}) => {
  const {t} = useTranslation(ns);

  return (
    <IconLabelBadge
      icon={METHOD_ICON[method]}
      label={t(`${labelKeyPrefix}.${method}`)}
      className={className}
    />
  );
};
